/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * HomePage.tsx
 */

import React from "react";
import PageSelector from "../../tools/view/layout/PageSelector";
import HiloReactComponent from "../../tools/view/layout/HiloReactComponent";
import PageComponent from "../../tools/view/layout/PageComponent";

export default class HomePage extends HiloReactComponent<{}, {}> {
    /**
     * render
     */
    public render(): JSX.Element {
        return <PageComponent>
            <PageSelector/>
        </PageComponent>
    }
}